module.exports = __webpack_public_path__ + "static/media/saving-yale-nus.a52e4aa5.png";